module.exports = __webpack_public_path__ + "img/ViajeBCN.69e7fca9.webp";